module.exports = __webpack_public_path__ + "static/img/exam-6-bg.a0acb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-6-bg.png
// module id = clwW
// module chunks = 1